import {
  buildVariableDefinitions,
  type DocumentVariableDefinition,
} from './documentTemplateVariables';

export function buildResolvedDocumentVariables(
  base:
    Record<string, string>,
  manual:
    Record<string, string>
) {
  return {
    ...base,
    ...manual,
  };
}

export function getMissingRequiredDocumentVariables(
  definitions:
    DocumentVariableDefinition[],
  values:
    Record<string, string>
) {
  return definitions.filter(
    (definition) =>
      definition.required &&
      !String(
        values[
          definition.key
        ] ?? ''
      ).trim()
  );
}

export function buildHistoricalDocumentVariableDefinitions(
  templateVersionVariables:
    string[],
  templateVersionVariablesSchema:
    DocumentVariableDefinition[],
  variablesSnapshot:
    Record<string, string>
) {
  if (
    templateVersionVariables.length >
      0 ||
    templateVersionVariablesSchema.length >
      0
  ) {
    const historicalKeys =
      templateVersionVariables.length > 0
        ? templateVersionVariables
        : templateVersionVariablesSchema.map(
            (definition) =>
              definition.key
          );

    const historicalRequiredKeys =
      templateVersionVariablesSchema
        .filter(
          (definition) =>
            definition.required
        )
        .map(
          (definition) =>
            definition.key
        );

    return buildVariableDefinitions(
      historicalKeys,
      templateVersionVariablesSchema,
      historicalRequiredKeys
    );
  }

  return buildVariableDefinitions(
    Object.keys(
      variablesSnapshot
    )
  );
}